import {Component, Input} from '@angular/core';
import {NgIf} from '@angular/common';
import {RouterLink} from '@angular/router';

@Component({
  selector: 'app-license-description',
  templateUrl: './license-description.component.html',
  styleUrls: ['./license-description.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    RouterLink,
  ]
})
export class LicenseDescriptionComponent {

  isStudent = false;
  isEmployee = false;
  isUniversity = false;

  constructor(private document: Document) {}

  @Input()
  set title(title: string) {
    const type = title.toLowerCase();
    this.isStudent = type === 'student';
    this.isEmployee = type === 'employee';
    this.isUniversity = type === 'university';
  }

  scrollToLicenseDetails(): void {
    const element = this.document.getElementById('licenseDetails');
    element?.scrollIntoView();
  }

}
